import React from 'react';
import { Row, Col, Button, Input, Form, Select, Modal, Radio } from 'antd';
import moment from 'moment';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { convertToIndianRupees } from 'helpers';
import { DATE_FORMAT } from 'constants/app-constants';
import TableComponent from 'components/table-component';

const MySwal = withReactContent(Swal);

const layer1FormCol = {
	labelCol: {
		span: 10,
	},
	wrapperCol: {
		span: 14,
	},
};

const DeliveryAndPaymentsListPresentational = ({
	getBillingItems,
	form,
	fetchingData,
	handleClear,
	form2,
	billDetails,
	updateStatusItems,
	updatingData,
	customers,
	handleCustomerSelect,
	customerModalVisible,
	handleModalClose,
	customerBills,
	loadingCustomerBills,
	selectedBillFromModal,
	setSelectedBillFromModal,
	handleApplyBill,
	selectedCustomer,
	handleReopenModal,
}) => {
	console.log('🚀 ~ file: delivery-and-payments-list-presenatational.js:28 ~ billDetails:', billDetails);
	
	const billColumns = [
		{
			title: 'Select',
			width: 80,
			align: 'center',
			render: (_, record) => (
				<Radio
					checked={selectedBillFromModal?._id === record._id}
					onChange={() => setSelectedBillFromModal(record)}
				/>
			),
		},
		{
			title: 'Bill #',
			dataIndex: 'billNumber',
			key: 'billNumber',
			width: 100,
			align: 'center',
		},
		{
			title: 'Bill Date',
			dataIndex: 'billDate',
			key: 'billDate',
			width: 120,
			align: 'center',
			render: (value) => moment(value).format(DATE_FORMAT.DD_MM_YYYY),
		},
		{
			title: 'Delivery Date',
			dataIndex: 'deliveryDate',
			key: 'deliveryDate',
			width: 120,
			align: 'center',
			render: (value) => value ? moment(value).format(DATE_FORMAT.DD_MM_YYYY) : '-',
		},
		{
			title: 'Unit Status',
			dataIndex: 'unitStatus',
			key: 'unitStatus',
			width: 150,
			align: 'center',
			render: (value) => (
				<span style={{ 
					fontSize: '11px',
					padding: '2px 6px',
					borderRadius: '4px',
					backgroundColor: value === 'Received From Unit' ? '#d4edda' : value === 'Sent To Unit' ? '#fff3cd' : '#f8d7da',
					color: value === 'Received From Unit' ? '#155724' : value === 'Sent To Unit' ? '#856404' : '#721c24',
					whiteSpace: 'nowrap',
				}}>
					{value || 'Pending'}
				</span>
			),
		},
		{
			title: 'Payment Status',
			dataIndex: 'paymentStatus',
			key: 'paymentStatus',
			width: 120,
			align: 'center',
			render: (value) => (
				<span style={{ 
					fontSize: '11px',
					padding: '2px 6px',
					borderRadius: '4px',
					backgroundColor: value === 'Paid' ? '#d4edda' : '#fff3cd',
					color: value === 'Paid' ? '#155724' : '#856404',
					whiteSpace: 'nowrap',
				}}>
					{value || 'Pending'}
				</span>
			),
		},
		{
			title: 'Delivery Status',
			dataIndex: 'deliveryStatus',
			key: 'deliveryStatus',
			width: 120,
			align: 'center',
			render: (value) => (
				<span style={{ 
					fontSize: '11px',
					padding: '2px 6px',
					borderRadius: '4px',
					backgroundColor: value === 'Delivered' ? '#d4edda' : '#fff3cd',
					color: value === 'Delivered' ? '#155724' : '#856404',
					whiteSpace: 'nowrap',
				}}>
					{value || 'Pending'}
				</span>
			),
		},
		{
			title: 'Qty',
			dataIndex: 'totalQty',
			key: 'totalQty',
			width: 80,
			align: 'center',
		},
		{
			title: 'Amount',
			dataIndex: 'totalAmount',
			key: 'totalAmount',
			width: 100,
			align: 'right',
			render: (value) => parseFloat(value || 0).toFixed(2),
		},
	];
	
	const showPropsConfirm = (title, value) => {
		MySwal.fire({
			title,
			text: "You won't be able to revert this!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#25b394',
			confirmButtonText: 'No',
			cancelButtonText: 'Yes',
		}).then((result) => {
			if (!result.isConfirmed) {
				setTimeout(() => {
					updateStatusItems(value);
					// form.submit();
				}, 100);
			} else {
				// form.submit();
			}
		});
	};
	return (
		<>
			<Modal
				title={`Bills for ${selectedCustomer?.displayName || 'Customer'}`}
				open={customerModalVisible}
				onCancel={handleModalClose}
				width={1200}
				footer={[
					<Button key="cancel" onClick={handleModalClose}>
						Cancel
					</Button>,
					<Button 
						key="apply" 
						type="primary" 
						onClick={handleApplyBill}
						disabled={!selectedBillFromModal}
					>
						Apply
					</Button>,
				]}
			>
				<TableComponent
					className="custom-table bills-modal-table"
					columns={billColumns}
					dataSource={customerBills}
					loading={loadingCustomerBills}
					rowKey={(record) => record._id}
					pagination={false}
					size="small"
					bordered
					onRow={(record) => ({
						onClick: () => setSelectedBillFromModal(record),
						style: { cursor: 'pointer' },
					})}
				/>
			</Modal>
			
			<Row>
				<Col span={18}>
					<Row>
						<Col span={12} style={{ padding: 20 }}>
							<Form
								labelAlign="left"
								name="delivery-and-payments"
								className="required_in_right"
								form={form}
								onFinish={getBillingItems}
								{...layer1FormCol}>
								<Row gutter={[20, 0]}>
									<Col xl={24} md={24}>
										<Form.Item
											label="Customer"
											name="customerId"
										>
											<Select
												showSearch
												placeholder="Select customer by name or mobile"
												onChange={handleCustomerSelect}
												filterOption={(input, option) => {
													const name = option?.name?.toLowerCase() || '';
													const mobile = option?.mobile?.toLowerCase() || '';
													const searchTerm = input.toLowerCase();
													return name.includes(searchTerm) || mobile.includes(searchTerm);
												}}
											>
												{customers?.map((customer) => (
													<Select.Option 
														key={customer._id} 
														value={customer._id}
														name={customer.displayName}
														mobile={customer.mobile}
													>
														{customer.displayName} - {customer.mobile}
													</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xl={24} md={24}>
										<Form.Item
											label="Bill No."
											name="fromBill"
											rules={[
												{
													required: true,
													message: 'This Field is required!',
												},
											]}>
											<Input style={{ width: '100%' }} />
										</Form.Item>
									</Col>
								<Col xl={24} md={24}>
									<Row gutter={[10, 0]}>
										<Col span={8}></Col>
										<Col span={16}>
											<Row gutter={[10, 0]}>
												<Col span={8}>
													<Button style={{ width: '100%' }} loading={fetchingData} type="primary" htmlType="submit">
														View
													</Button>
												</Col>
												<Col span={8}>
													<Button 
														style={{ width: '100%' }} 
														loading={fetchingData} 
														onClick={handleReopenModal}
														disabled={!selectedCustomer && !form.getFieldValue('customerId')}
													>
														Reopen
													</Button>
												</Col>
												<Col span={8}>
													<Button style={{ width: '100%' }} loading={fetchingData} danger onClick={handleClear}>
														Clear
													</Button>
												</Col>
											</Row>
											{billDetails ? (
												<>
													<Row gutter={[10, 10]} style={{ paddingTop: 10 }}>
														<Col span={24}>
															<Button
																disabled={!('Pending' === billDetails?.paymentStatus)}
																style={{ width: '100%', height: 60 }}
																loading={updatingData}
																onClick={() => showPropsConfirm('Are you sure want to change this to Paid?', 'Paid')}>
																Paid
															</Button>
														</Col>
														<Col span={24}>
															<Button
																disabled={
																	!('Pending' === billDetails?.deliveryStatus) ||
																	!('Received From Unit' === billDetails?.unitStatus)
																}
																style={{ width: '100%', height: 60 }}
																loading={updatingData}
																// onClick={() => updateStatusItems('Delivered')}>
																onClick={() =>
																	showPropsConfirm('Are you sure want to change this to Delivered?', 'Delivered')
																}>
																Delivered
															</Button>
														</Col>
														<Col span={24}>
															<Button
																disabled={
																	!('Pending' === billDetails?.paymentStatus) ||
																	!('Pending' === billDetails?.deliveryStatus) ||
																	!('Received From Unit' === billDetails?.unitStatus)
																}
																// disabled={
																// 	'Delivered' === billDetails?.deliveryStatus ||
																// 	'Paid' === billDetails?.paymentStatus
																// }
																style={{ width: '100%', height: 60 }}
																loading={updatingData}
																// onClick={() => updateStatusItems('PaidDelivered')}>
																onClick={() =>
																	showPropsConfirm(
																		'Are you sure want to change this to Paid & Delivered?',
																		'PaidDelivered'
																	)
																}>
																Paid & Delivered
															</Button>
														</Col>
													</Row>
													<Row gutter={[10, 10]}>
														<Col span={24}>
															<div className="delivery-status-amount">
																{convertToIndianRupees(billDetails?.totalAmount || 0)}
															</div>
														</Col>
													</Row>
												</>
											) : null}
										</Col>
									</Row>
								</Col>
							</Row>
						</Form>
					</Col>
					<Col span={12} style={{ padding: 20 }}>
						<Form
							labelAlign="left"
							name="delivery-and-payments"
							className="required_in_right"
							form={form2}
							onFinish={getBillingItems}
							{...layer1FormCol}>
							<Row gutter={[20, 0]}>
								<Col xl={24} md={24}>
									<Form.Item label="Unit Status" name="unitStatus">
										<Input style={{ width: '100%' }} disabled />
									</Form.Item>
								</Col>
								<Col xl={24} md={24}>
									<Form.Item label="Payment Status" name="paymentStatus">
										<Input style={{ width: '100%' }} disabled />
									</Form.Item>
								</Col>
								<Col xl={24} md={24}>
									<Form.Item label="Delivery Status" name="deliveryStatus">
										<Input style={{ width: '100%' }} disabled />
									</Form.Item>
								</Col>
								<Col xl={24} md={24}>
									<Form.Item label="Total Qty" name="totalQty">
										<Input style={{ width: '100%' }} disabled />
									</Form.Item>
								</Col>
								<Col xl={24} md={24}>
									<Form.Item label="Customer" name="customer">
										<Input style={{ width: '100%' }} disabled />
									</Form.Item>
								</Col>
								<Col xl={24} md={24}>
									<Form.Item label="Mobile" name="mobile">
										<Input style={{ width: '100%' }} disabled />
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Col>
		</Row>
		</>
	);
};

export default DeliveryAndPaymentsListPresentational;
